module.exports = __webpack_public_path__ + "img/censored-chrome.5bef1fc9.jpeg";